import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [FooterComponent, HeaderComponent],
  imports: [RouterModule, CommonModule],
  exports: [FooterComponent, HeaderComponent]
})
export class CoreModule {}
